<template>
  <div class="informationmain">
    <div class="main">
      <div class="bgc"></div>
      <div class="Info">
        <!-- <div class="Info-bgc">
          <p>工商信息</p>
          <div class="con">
            <img src="../../assets/信息1.png" alt="工商信息" />
          </div>
        </div> -->
        <div class="Info-bgc">
          <p>工商信息</p>
          <div class="con">
            <div class="box" v-for="(item,index) in list" :key="index">
              <div class="boxL">
                {{ item.name }}
              </div>
              <div class="boxR">
                {{ item.content }}
              </div>
            </div>
          </div>
        </div>

        <div class="Info-bgc">
          <p>股权结构</p>
          <div class="con">
            <img src="../../assets/股权架构.png" alt="股权结构"/>
          </div>
        </div>
        <div class="Info-bgc">
          <p>董监高成员</p>
          <div class="con">
            <p>董事会成员</p>
            <div class="box" v-for="(item,index) in directorList" :key="index">
              <div class="boxL">
                {{ item.label }}
              </div>
              <div class="withinR">
                <div
                  class="dynamicBox"
                  v-for="(val, i) in item.values"
                  :key="i"
                >{{ val }}</div>
              </div>
            </div>
            <p>监事会成员</p>
            <div class="box" v-for="(item,index) in supervisorList" :key="index + '-only'">
              <div class="boxL">
                {{ item.label }}
              </div>
              <div class="withinR">
                <div
                  class="dynamicBox"
                  v-for="(val, i) in item.values"
                  :key="i"
                  :style="{ width: (100 / item.values.length) + '%' }"
                >{{ val }}</div>
              </div>
            </div>
            <p>高管成员</p>
            <div class="box" v-for="(item,index) in userList" :key="index + '+only'">
              <div class="boxL">
                {{ item.label }}
              </div>
              <div class="withinR">
                <div
                  class="dynamicBox"
                  v-for="(val, i) in item.values"
                  :key="i"
                  :style="{ width: (100 / item.values.length) + '%' }"
                >{{ val }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="Info-bgc">
          <p>组织结构</p>
          <div class="con">
            <img src="../../assets/组织架构.png" alt="组织结构"/>
          </div>
        </div>
        <div class="Info-bgc">
          <p>企业平台</p>
          <div class="con">
            <p>
              1 获客平台： 德吉特平台
              <a href="javascirpt:void(0)" @click="jrclick"
              >https://www.jrcreditunion.com</a
              >，ICP许可证编号：粤B2-20190161
            </p>
            <p>2 官方平台：https://www.longxie.net</p>
            <p>3 微信公众号：隆携信贷</p>
            <div class="ma">
              <img src="../../assets/微信二维码.jpg" alt="二维码"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "information",
  data() {
    return {
      list: [
        {
          name: '统一社会信用代码',
          content: '9150010769120276XP'
        },
        {
          name: '营业期限',
          content: '2009 06-18至无固定期限'
        },
        {
          name: '注册资本',
          content: '50亿元'
        },
        {
          name: '联系电话',
          content: '400-100-3066'
        },
        {
          name: '法定代表人',
          content: '王军'
        },
        {
          name: '注册地址',
          content: '重庆市九龙坡区科园一路30号14层1402号'
        },
        {
          name: '成立时间',
          content: '2009-06-18'
        },
        {
          name: '企业类型',
          content: '有限责任'
        },
        {
          name: '经营范围',
          content: '开展各项贷款、票据贴现、资产转让、以自有资金进行股权投资。其中，自营贷款可通过市金融办核准和备案的网络平台在全国范围内开展；股权投资可在全国范围内开展，但不得超过注册资本的30%。'
        },
      ],
      directorList: [
        {
          label: '职务',
          values: ['董事长兼法定代表人', '董事', '董事'],
        },
        {
          label: '姓名',
          values: ['王军', '唐百元', '张晓拂'],
        },
      ],
      supervisorList: [
        {
          label: '职务',
          values: ['职工监事'],
        },
        {
          label: '姓名',
          values: ['陈永'],
        },
      ],
      userList: [
        {
          label: '职务',
          values: ['总经理', '副总经理'],
        },
        {
          label: '姓名',
          values: ['张晓拂', '刘多'],
        },
      ],
    }
  },
  methods: {
    jrclick() {
      window.open("https://www.jrcreditunion.com", "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.informationmain {
  height: 100%;

  .main {
    height: 100%;

    .bgc {
      width: 100%;
      height: 500px;
      background: url("../../assets/信息披露.jpg") center bottom no-repeat;
      background-size: 100% 122%;
      background-position-y: -80px;
      image-rendering: -moz-crisp-edges;
      image-rendering: -o-crisp-edges;
      image-rendering: -webkit-optimize-contrast;
      image-rendering: crisp-edges;
      -ms-interpolation-mode: nearest-neighbor;
    }

    .Info {
      padding: 20px;
      margin-top: 30px;

      p {
        margin: 0;
      }

      .Info-bgc {
        padding: 20px;
        text-align: center;
        background-color: #fff;

        p {
          text-align: left;
          font-size: 20px;
          padding-bottom: 10px;
          font-weight: bold;
        }

        .con {
          .box {
            display: flex;
            border: #e7e7e7 1px solid;
            background-color: #ffffff;

            .boxL {
              background-color: #007aff;
              width: 10%;
              color: white;
              padding: 15px 15px;
            }

            .boxR {
              width: 90%;
              padding: 15px 15px;
              display: flex;
              justify-content: center;
            }

            .withinR {
              width: 90%;
              display: flex;
              justify-content: center;
            }

            .dynamicBox {
              flex: 1;
              display: flex;
              justify-content: center;
              align-items: center;
              border-right: 1px solid #e7e7e7;
              padding: 15px 10px;
              &:last-child {
                border-right: none;
              }
            }
          }

          img {
            width: 100%;
          }

          margin: 0 auto;
          padding: 20px;
          background-color: #f2f2f2;

          p {
            font-size: 16px;
            padding: 20px 0;
          }

          img {
            display: inline-block;
            // width: 80%;
            height: 100%;
            image-rendering: -moz-crisp-edges;
            image-rendering: -o-crisp-edges;
            image-rendering: -webkit-optimize-contrast;
            image-rendering: crisp-edges;
            -ms-interpolation-mode: nearest-neighbor;
          }

          .ma {
            width: 200px;
            text-align: left;

            img {
              width: 200px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/Information/index.vue